import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Admin from './pages/Admin';
import AdminProducts from './pages/admin/AdminProducts';
import AdminInventory from './pages/admin/AdminInventory';
import AdminOrders from './pages/admin/AdminOrders';
import AdminFinance from './pages/admin/AdminFinance';
import AdminProjects from './pages/admin/AdminProjects';
import Contact from './pages/Contact';
import Shop from './pages/Shop';
import Product from './pages/Product';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Profile from './pages/Profile';
import Checkout from './pages/Checkout';
import ThankYou from './pages/ThankYou';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Withdrawal from './pages/Withdrawal';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/termekek" element={<AdminProducts />} />
      <Route path="/admin/beszerzes" element={<AdminInventory />} />
      <Route path="/admin/rendelesek" element={<AdminOrders />} />
      <Route
        path="/admin/felbehagyott-penztarak"
        element={<Navigate to="/admin/rendelesek?nez=felbehagyott" replace />}
      />
      <Route path="/admin/szallitok" element={<Navigate to="/admin/termekek" replace />} />
      <Route path="/admin/penzugy" element={<AdminFinance />} />
      <Route path="/admin/projekt" element={<AdminProjects />} />
      <Route path="/admin/rednelesek" element={<AdminOrders />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/product/:id" element={<Product />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/bejelentkezes" element={<Login />} />
      <Route path="/profil" element={<Profile />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/elallasi-jog" element={<Withdrawal />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
